module.exports = __webpack_public_path__ + "img/imgZXGH(22).bbb071f1.png";